module.exports = __webpack_public_path__ + "static/img/review.fe396512.png";